import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCategoryList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditCategoryModal from './Add_Edit/AddEditCategory';
import DeleteCategoryModal from './Delete/DeleteCategory';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getWarehouseCategoryList } from '../../../slices/warehouseCategory/thunk';

const CategoriesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorCategories = createSelector(
		state => state.WarehouseCategory,
		data => ({
			dataList: data.itemWarehouseCategoryList,
			isLoadingList: data.isLoadingList,
			isCategorySuccess: data.isCategorySuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { dataList, isLoadingList } = useSelector(selectorCategories);

	useEffect(() => {
		dispatch(getWarehouseCategoryList());
	}, []);

	const [dataCategory, setDataCategory] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Category
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataCategory(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataCategory(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'categories',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',

				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataCategory({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Categoría
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={dataList || []}
								isLoadingData={isLoadingList}
								nameFile={'categorias'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataCategory({});
											handleToggleModal();
										},
										title: 'Crear Categoría',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditCategoryModal
				dataCategory={dataCategory}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteCategoryModal
				dataCategory={dataCategory}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default CategoriesList;
